import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../../../shared';
import { RouterModule } from '@angular/router';
import { INVENTORY_DETAILS_ROUTES } from './inventory-details.route';
import { InventoryDetailsComponent } from './inventory-details.component';
import { LotComponent } from './lot.component';
import { TransactionComponent } from './transaction.component';
import { InventoryDetailsModalComponent, InventoryDetailsPopupComponent } from './inventory-details-modal.component';
import { TransactionDetailsModalComponent } from './transaction-details-modal.component';
import { InventoryDetailsMainComponent } from './inventory-details-main.component';
import { LotMainComponent } from './lot-main.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(INVENTORY_DETAILS_ROUTES)
    ],
    declarations: [
        InventoryDetailsComponent,
        InventoryDetailsModalComponent,
        InventoryDetailsPopupComponent,
        LotComponent,
        TransactionComponent,
        TransactionDetailsModalComponent,
        InventoryDetailsMainComponent,
        LotMainComponent
    ],
    exports: [
        TransactionComponent
    ],
    providers: []
})
export class InventoryDetailsModule {

}
